import {
    allFetch
} from "../Domain";

/**
 * @description 使用者職務
 */
export const UserLevel = (() => {
    /**
     * @description 職務查詢
     * @param {string} code 代碼
     * @param {string} name 名稱
     * @param {string} parent_id 母職務編號
     * @param {string} company_id 公司流水號
     * @param {string} general_manager_id 高階管理階層（前總經理室）流水號
     * @param {string} department_id 部門流水號
     * @param {string} position_id 廠別流水號
     * @param {string} class_id 課級流水號
     * @param {string} group_id 組級流水號
     * @param {string} office_id 辦公室流水號
     * @param {string} disable 帳號狀態
     * @param {string} isresign 是否離職
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns res
     */
    const UserLevelSearch = async (obj = {
        code: '',
        name: '',
        parent_id: '',
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        disable: '',
        isresign: '',
        page: '',
        num_per_page: ''
    }) => {
        return await allFetch("UserLevel/UserLevelSearch", obj);
    }
    /**
     * @description 職務查詢(無視權限選所有職務  職責選邏輯主管用)
     * @param {string} code 代碼
     * @param {string} name 名稱
     * @param {string} parent_id 母職務編號
     * @param {string} company_id 公司流水號
     * @param {string} general_manager_id 高階管理階層（前總經理室）流水號
     * @param {string} department_id 部門流水號
     * @param {string} position_id 廠別流水號
     * @param {string} class_id 課級流水號
     * @param {string} group_id 組級流水號
     * @param {string} office_id 辦公室流水號
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns res
     */
    const UserLevelSearchAll = async (obj) => {
        return await allFetch("UserLevel/UserLevelSearchAll", obj);
    }
    /**
     * @description 職務檢查是否存在
     * @param {*} obj 
     * @returns 
     */
    const UserLevelExist = async (obj = {
        code: ""
    }) => {
        return await allFetch("UserLevel/UserLevelExist", obj);
    }
    /**
     * @description 新建職務
     * @param {*} obj 
     * @returns 
     */
    const UserLevelCreate = async (obj) => {
        return await allFetch("UserLevel/UserLevelCreate", obj);
    }
    /**
     * @description 刪除職務
     * @param {string} ul_id 職務編號
     * @returns 
     */
    const UserLevelDelete = async (obj = {
        ul_id: ''
    }) => {
        return await allFetch("UserLevel/UserLevelDelete", obj);
    }
    /**
     * @description 職務細項
     * @param {string} ul_id 職務編號
     * @returns 
     */
    const UserLevelDetail = async (obj = {
        ul_id: ''
    }) => {
        return await allFetch("UserLevel/UserLevelDetail", obj);
    }
    /**
     * @description 修改職務
     * @param {*} obj 
     * @returns 
     */
    const UserLevelUpdate = async (obj) => {
        return await allFetch("UserLevel/UserLevelUpdate", {
            ...obj,
            level_audit_type: typeof obj.level_audit_type === "string" ? JSON.parse(obj.level_audit_type) : obj.level_audit_type
        });
    }
    /**
     * @description 更新職務對應職責
     * @param {*} obj 
     * @returns 
     */
    const UserLevelUpdateDuty = async (obj) => {
        return await allFetch("UserLevel/UserLevelUpdateDuty", obj);
    }
    /**
     * @description 修改職務的審核名目和種類們
     * @param {*} obj 
     * @returns 
     */
    const UserLevelUpdateAuditType = async (obj) => {
        return await allFetch("UserLevel/UserLevelUpdateAuditType", obj);
    }
    /**
     * @description 修改職務的訂單相關欄位
     * @param {*} obj 
     * @returns 
     */
    const UserLevelUpdateOrderRelate = async (obj) => {
        return await allFetch("UserLevel/UserLevelUpdateOrderRelate", obj);
    }
    /**
     * @description 修改職務的PDI相關欄位
     * @param {*} obj 
     * @returns 
     */
    const UserLevelUpdatePDIRelate = async (obj) => {
        return await allFetch("UserLevel/UserLevelUpdatePDIRelate", obj);
    }

    /**
     * @description 職務查詢(樹狀圖)
     * @param {string} ul_id 職務編號
     * @returns 
     */
    const UserLevelTreeDiagram = async (obj) => {
        return await allFetch("UserLevel/UserLevelTreeDiagram", obj);
    }

    return {
        UserLevelSearch,
        UserLevelSearchAll,
        UserLevelExist,
        UserLevelCreate,
        UserLevelDelete,
        UserLevelDetail,
        UserLevelUpdate,
        UserLevelUpdateDuty,
        UserLevelUpdateAuditType,
        UserLevelUpdateOrderRelate,
        UserLevelUpdatePDIRelate,
        UserLevelTreeDiagram
    }
})();